import React, { useEffect } from 'react';
import { Box, Grid } from '@mui/material';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import {
  DashboardContainer,
  HeaderContainer,
  HeaderTitle,
  ActionButton,
} from './style';

import ShiftOverview from './components/ShiftOverview';
import ShiftStatus from './components/ShiftStatus';
import ShiftSchedule from './components/ShiftSchedule';
import AssignedWorkers from './components/AssignedWorkers';
import { useNavigate } from 'react-router-dom';
import { useSidebar } from '../../context/SidebarContext';
import { useBreadcrumb } from '../../context/BreadcrumbContext';

const FacilityDashboard: React.FC = () => {
  const { setActivePage } = useSidebar();
  const { setIsShow } = useBreadcrumb();
  useEffect(() => {
    setActivePage('dashboard');
    setIsShow(false);
  }, [setActivePage, setIsShow]);

  const navigate = useNavigate();
  const handleEditShift = () => {
    navigate('/facility/shifts');
  }

  const handleAddShift = () => {
    navigate('/facility/shift/create');
  }

  return (
    <DashboardContainer>
      <HeaderContainer>
        <HeaderTitle>Shift Overview</HeaderTitle>
        <Box>
          <ActionButton
            variant="outlined"
            onClick={handleEditShift}
            sx={{
              borderColor: '#1565c0',
              color: '#1565c0'
            }}
          >
            Edit Upcoming Shift
          </ActionButton>
          <ActionButton
            variant="contained"
            onClick={handleAddShift}
            disableElevation
            startIcon={<AddCircleOutlineIcon />}
            sx={{
              backgroundColor: '#e8f5e9',
              color: '#2e7d32',
              '&:hover': { backgroundColor: '#c8e6c9' }
            }}
          >
            Add New Shift
          </ActionButton>
        </Box>
      </HeaderContainer>

      {/* Top Grid: Stats + Pie Chart */}
      <Grid container spacing={3}>
        <Grid size={{ xs: 12, md: 7 }} sx={{ display: 'flex' }}>
          <ShiftOverview />
        </Grid>

        <Grid size={{ xs: 12, md: 5 }} sx={{ display: 'flex' }}>
          <ShiftStatus />
        </Grid>
      </Grid>

      {/* Bottom Grid: Schedule + Workers */}
      <Grid container spacing={3} sx={{ mt: 3 }}>
        <Grid size={{ xs: 12, md: 5 }} sx={{ display: 'flex', flexDirection: 'column' }}>
          <ShiftSchedule />
        </Grid>

        <Grid size={{ xs: 12, md: 7 }} sx={{ display: 'flex', flexDirection: 'column' }}>
          <AssignedWorkers />
        </Grid>
      </Grid>
    </DashboardContainer>
  );
};

export default FacilityDashboard;
